import CityPageTemplate from "../city-template/CityPageTemplate";
import { chattanoogaConfig } from "./data";

export default function ChattanoogaPage() {
  return <CityPageTemplate config={chattanoogaConfig} />;
}